import { Controller } from "@hotwired/stimulus"

// reCAPTCHA v3 compatible con Turbo.
// - Carga api.js una sola vez (idempotente ante navegaciones de Turbo).
// - Genera un token FRESCO al enviar el formulario (evita el error de
//   "placeholder must be empty" y la caducidad del token a los 2 minutos).
export default class extends Controller {
  static values = { siteKey: String, action: { type: String, default: "submit" } }
  static targets = ["token"]

  connect() {
    this.ready = this.loadApi()
  }

  loadApi() {
    return new Promise((resolve) => {
      if (window.grecaptcha && window.grecaptcha.execute) return resolve()
      if (!document.querySelector("script[data-recaptcha-api]")) {
        const s = document.createElement("script")
        s.src = `https://www.google.com/recaptcha/api.js?render=${this.siteKeyValue}`
        s.async = true
        s.defer = true
        s.dataset.recaptchaApi = "true"
        document.head.appendChild(s)
      }
      const start = Date.now()
      const poll = () => {
        if (window.grecaptcha && window.grecaptcha.execute) resolve()
        else if (Date.now() - start > 8000) resolve() // se rinde tras 8s
        else setTimeout(poll, 50)
      }
      poll()
    })
  }

  // data-action="submit->recaptcha#execute"
  execute(event) {
    if (this.tokenTarget.value) return // ya hay token: deja que el envío continúe
    event.preventDefault()
    this.ready.then(() => {
      const grecaptcha = window.grecaptcha
      if (!grecaptcha || !grecaptcha.execute) {
        this.element.requestSubmit() // reCAPTCHA no disponible: el servidor decidirá
        return
      }
      grecaptcha.ready(() => {
        grecaptcha
          .execute(this.siteKeyValue, { action: this.actionValue })
          .then((token) => {
            this.tokenTarget.value = token
            this.element.requestSubmit()
          })
      })
    })
  }
}
